import { SxProps } from "@mui/material";

export const sxButton: SxProps = {
    padding: '12px',
    fontSize: '18px',
    lineHeight: '24px',
    fontFamily: 'Montserrat-Regular',
    borderRadius: 0,
    width: "fit-content",
    textTransform: "none",
    '&.MuiButton-contained': {
        backgroundColor: 'var(--primary-blue)',
        '&:hover': {
            opacity: '0.7'
        },
    },
    '&.MuiButton-outlined': {
        color: 'var(--primary-blue)',
        backgroundColor: 'var(--primary-white)',
        fontWeight: 600,
        border: 1,
        padding: '12px 32px',
        '&:hover': {
            opacity: '0.7'
        },
    },
    "&.Mui-disabled": {
        opacity: 0.7,
        color: 'white'
    }
}
